<template>
  <el-row class="dormitory-log-main">
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="已安装"
                   name="old"></el-tab-pane>
      <el-tab-pane label="新设备"
                   name="new"></el-tab-pane>
    </el-tabs>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="设备名称:"
                      prop="descr">
          <el-input v-model.trim="searchForm.descr"
                    placeholder="设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 在线状态 1在线 0不在线 -->
        <el-form-item label="在线状态:"
                      prop="online">
          <el-select v-model="searchForm.online"
                     placeholder="在线状态">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="在线"
                       value="1"></el-option>
            <el-option label="离线"
                       value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="告警状态:"
                      prop="alarm">
          <el-select v-model="searchForm.alarm"
                     placeholder="告警状态">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="告警"
                       value="1"></el-option>
            <el-option label="正常"
                       value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <!-- <el-button type="primary"
                 @click="handleConfirm('manForm')">
        确 定
      </el-button> -->
      <el-drawer title="告警列表"
                 :visible.sync="drawer"
                 :direction="direction"
                 size="700px"
                 @closed="handleDrawerClose">
        <FacilityAlarm :id="facilityId"
                       @confirm-count="handleConfirmCount" />
      </el-drawer>

    </el-row>
    <el-card shadow="none">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="60"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'online'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger"> off </el-tag>
              <el-tag v-else
                      type="success"> on </el-tag>
            </template>
            <template v-else-if="item.prop === 'alarm'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="success"> 正常 </el-tag>
              <el-tag v-else
                      type="danger"> 告警 </el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :width="150">
          <template slot-scope="scope">
            <el-button v-if="activeName === 'old'"
                       size="mini"
                       type="danger"
                       plain
                       @click="handleDrawer(scope.row)">事件</el-button>
            <el-popover v-has="'/firefacilities/edit'"
                        placement="bottom"
                        trigger="click">
              <el-button v-has="'/firefacilities/edit'"
                         size="mini"
                         type="text"
                         @click="handleEdit(scope.row)">编辑</el-button>
              <!-- <el-button v-if="scope.row.activated === '1'"
                       size="mini"
                       type="text"
                       @click="handleDelete(scope.row)">注销</el-button> -->
              <el-button slot="reference"
                         plain
                         size="mini"
                         type="primary"
                         style="margin-left: 10px;">更多</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <edit-facilitie v-if="showEditModal"
                    :isShow="showEditModal"
                    :data="editData"
                    @handleClose="closeEdit"></edit-facilitie>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import EditFacilitie from '@/views/device/fireFacilities/EditFacilitie'
import FacilityAlarm from '@/views/device/fireFacilities/FacilityAlarmList'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { EditFacilitie, Pagination, FacilityAlarm },
  data() {
    return {
      // 抽屉
      drawer: false,
      direction: 'rtl',
      facilityId: '',
      alarmConfirmCount: 0,
      // 选项卡标记
      activeName: 'old',
      areaList: [],
      searchForm: {
        descr: '',
        area_id: '',
        online: '',
        alarm: ''
      },
      tableTitle: [
        {
          prop: 'area_name',
          name: '区域',
          width: '230'
        },
        {
          prop: 'room_name',
          name: '房间',
          width: '120'
        },
        {
          prop: 'descr',
          name: '名称',
          width: '120'
        },
        {
          prop: 'addrStr',
          name: '编码',
          width: '160'
        },
        {
          prop: 'facilitiesModel',
          name: '型号',
          width: '120'
        },
        {
          prop: 'facilitiesCodeName',
          name: '类别',
          width: '120'
        },
        {
          prop: 'facilitiesTypeCodeName',
          name: '类型',
          width: '120'
        },
        {
          prop: 'voltage',
          name: '电量',
          width: '80'
        },
        {
          prop: 'online',
          name: '在线状态',
          width: '80'
        },
        {
          prop: 'alarm',
          name: '告警状态',
          width: '80'
        },
        {
          prop: 'longitude',
          name: '经度',
          width: '160'
        },
        {
          prop: 'latitude',
          name: '纬度',
          width: '160'
        },
        {
          prop: 'up_time',
          name: '更新时间',
          width: '160'
        },
        {
          prop: 'reg_time',
          name: '注册时间',
          width: '160'
        },
        // {
        //   prop: 'activated',
        //   name: '激活状态',
        //   width: '80'
        // },
        {
          prop: 'remarks',
          name: '备注',
          width: '160'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 定义进度条颜色
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#67c23a', percentage: 100 }
      ],
      // 编辑弹窗
      showEditModal: false,
      editData: {},
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getFacilitieList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 编辑
    handleEdit(data) {
      this.showEditModal = true
      this.editData = {
        id: data.id
      }
    },
    closeEdit(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showEditModal = false
    },
    // 告警展示
    handleDrawer(data) {
      this.facilityId = data.facilityId
      this.drawer = true
    },
    // 告警确认增加
    handleConfirmCount(val) {
      this.alarmConfirmCount = val
    },
    // 关闭告警展示
    handleDrawerClose() {
      if (this.alarmConfirmCount > 0) {
        console.log('confirm count > 0')
        this.alarmConfirmCount = 0
        this.getList()
      }
    }
  }
}
</script>

<style lang="less">
.dormitory-log-main {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #409eff;
  }
}
</style>
